/**
 * @file pager
 */
(function ($, Drupal, once) {
  "use strict";

  Drupal.behaviors.kodakPager = {
    attach: function (context, settings) {
      if ($(".pager").length > 0) {
        $(".pager").each(function () {
          var scrollToSection =
            $(this).parents(".paragraph").offset().top - 150;
          $(this)
            .find(".pager__item a")
            .click(function (e) {
              setTimeout(function () {
                $("html, body").animate({ scrollTop: scrollToSection }, 200);
              }, 200);
            });
        });
      }
    },
  };
})(jQuery, Drupal, once);
